<template>
  <div class="report-biweekly-send-on">
    <div class="btn-group-spaced is-justified">
      <label class="label text-lighter"> {{ label }} on: </label>
      <AppButton
        v-for="day in availableDays"
        :key="day.format()"
        class="btn-sm btn-default btn-rounded"
        :class="{ active: isDaySelected(day) }"
        @click="selectDay(day)"
      >
        {{ $filters.formatDate(day) }}
      </AppButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportScheduledReportBiweeklySendOn',
  props: {
    value: {},
    deliveryTime: {
      required: true,
    },
    deliveryDays: {
      required: true,
    },
    timeZone: {
      type: String,
      required: true,
    },
    nextSendingAt: {},
  },
  emits: ['input'],
  data() {
    return {
      now: moment(),
      selectedDay: null,
    };
  },
  computed: {
    label() {
      return this.nextSendingAt ? 'Send next' : 'Start';
    },
    nextSendingAtInZone() {
      let nextSendingAt;

      if (this.nextSendingAt) {
        nextSendingAt = moment(this.nextSendingAt).tz(this.timeZone);
      }

      return nextSendingAt;
    },
    availableDays() {
      const deliveryTime = moment.utc(this.deliveryTime);
      const availableDays = [];
      let firstTime;

      if (this.value && this.value.isAfter() && this.deliveryDays.includes(this.value.day())) {
        firstTime = this.value.clone().tz(this.timeZone);
      } else {
        firstTime = this.now.clone().set({
          hour: deliveryTime.hour(),
          minute: deliveryTime.minute(),
          second: 0,
          millisecond: 0,
        });
        firstTime.tz(this.timeZone, true);

        while (firstTime.isBefore(this.now) || !this.deliveryDays.includes(firstTime.day())) {
          firstTime.add(1, 'day');
        }
      }

      availableDays.push(firstTime);

      if (firstTime.isAfter(this.now.clone().add(1, 'week'))) {
        availableDays.unshift(firstTime.clone().subtract(1, 'week'));
      } else {
        availableDays.push(firstTime.clone().add(1, 'week'));
      }

      return availableDays;
    },
  },
  watch: {
    availableDays() {
      let selectedDay;
      const currentDay = this.value || this.nextSendingAtInZone;

      if (currentDay) {
        selectedDay = this.availableDays.find((day) => day.isSame(currentDay, 'day'));
      }

      if (!selectedDay) {
        selectedDay = this.availableDays[0];
      }

      if (!this.selectedDay.isSame(selectedDay, 'day')) {
        this.selectDay(selectedDay);
      }
    },
    deliveryTime() {
      if (this.selectedDay) {
        const deliveryTime = moment.utc(this.deliveryTime);

        this.selectedDay.set({
          hour: deliveryTime.hour(),
          minute: deliveryTime.minute(),
        });
        this.emit();
      }
    },
  },
  created() {
    if (this.nextSendingAtInZone && this.isAvailableDay(this.nextSendingAtInZone)) {
      this.selectedDay = this.nextSendingAtInZone;
    } else {
      this.selectDay(this.availableDays[0]);
    }
  },
  methods: {
    isAvailableDay(day) {
      return this.availableDays.some((availableDay) => availableDay.isSame(day, 'day'));
    },
    isDaySelected(date) {
      return date.isSame(this.selectedDay, 'day');
    },
    selectDay(day) {
      this.selectedDay = day.clone();
      this.emit();
    },
    emit() {
      this.$emit('input', this.selectedDay);
    },
  },
};
</script>
